export const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long' };

export function getDayMonthTodayString(lang: string) {
  return new Date().toLocaleString(lang, options);
}

export function getDayMonthTomorrowString(lang: string) {
  return new Date(Date.now() + 3600 * 1000 * 24).toLocaleString(lang, options);
}

export function getDayMonthAfterTomorrowString(lang: string) {
  return new Date(Date.now() + 3600 * 1000 * 24 * 2).toLocaleString(lang, options);
}
